var _circle, _circle2, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcEmail = function SvgIcEmail(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#D2ECFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.728,
    cy: 19.726,
    r: 16.9213,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4227 22.0169C20.2836 22.1038 20.127 22.1386 19.9879 22.1386C19.8488 22.1386 19.6923 22.1038 19.5532 22.0169L12.6318 17.791V23.4081C12.6318 24.608 13.6057 25.5819 14.8056 25.5819H25.1876C26.3875 25.5819 27.3614 24.608 27.3614 23.4081V17.791L20.4227 22.0169Z",
    fill: "#328FFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1884 14.7314H14.8064C13.7803 14.7314 12.9108 15.4618 12.7021 16.4357L20.0061 20.8876L27.2926 16.4357C27.0839 15.4618 26.2144 14.7314 25.1884 14.7314Z",
    fill: "#328FFC"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-email.15acb8dd.svg";
export { ForwardRef as ReactComponent };